import moment from "moment-timezone";
import { SAITAMA_INSPECTION_LABELS } from "../../config/SaitamaInspectionItems";

export const SAITAMA_CSV_HEADERS = ["管理ID", "撮影者", "撮影日時", "点検結果"];

export const getSaitamaInspectionCsvLabel = (row = {}) => {
  if (row.inspectionStatus === "INVALID_MIXED") {
    throw new Error("異常なしと異常項目が混在した点検結果はCSV出力できません");
  }
  if (row.inspectionStatus === "UNINSPECTED") return "未点検";
  if (row.inspectionStatus === "NO_ABNORMALITY") return "異常なし";

  const codes = Array.isArray(row.inspectionItemCodes) ? [...new Set(row.inspectionItemCodes)] : [];
  if (codes.length === 0) {
    throw new Error("点検結果の項目がありません");
  }
  const labels = codes.map((code) => {
    const label = SAITAMA_INSPECTION_LABELS[code];
    if (!label || code === "NO_ABNORMALITY") {
      throw new Error(`未定義の点検項目コードです: ${code}`);
    }
    return label;
  });
  return labels.join("・");
};

export const formatSaitamaCsvDatetime = (value) => {
  if (value == null || value === "") return "";
  return String(value)
    .replace("T", " ")
    .replace(/\.\d{1,6}(Z|[+-]\d{2}:?\d{2})$/, "")
    .replace(/(Z|[+-]\d{2}:?\d{2})$/, "")
    .slice(0, 19);
};

export const buildSaitamaCsvRows = (rows = []) => [
  SAITAMA_CSV_HEADERS,
  ...rows.map((row) => [
    row.saitama_management_id ?? row.management_id ?? "",
    row.name || row.player_id || "",
    formatSaitamaCsvDatetime(row.occurred_datetime_jst || row.occurred_datetime),
    getSaitamaInspectionCsvLabel(row),
  ]),
];

export const escapeSaitamaCsvField = (value) => {
  const field = String(value ?? "");
  return /[",\r\n]/.test(field) ? `"${field.replace(/"/g, '""')}"` : field;
};

export const serializeSaitamaCsv = (rows = []) => {
  const csvRows = buildSaitamaCsvRows(rows);
  return `\uFEFF${csvRows.map((row) => row.map(escapeSaitamaCsvField).join(",")).join("\r\n")}\r\n`;
};

export const buildSaitamaCsvFilename = (date = new Date()) =>
  `streetlight_inspection_${moment(date).tz("Asia/Tokyo").format("YYYYMMDDHHmm")}.csv`;
